import React, { useEffect, useState, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import { api } from '../api.js';

const I = {
  dashboard: () => <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="9" rx="1"/><rect x="14" y="3" width="7" height="5" rx="1"/><rect x="14" y="12" width="7" height="9" rx="1"/><rect x="3" y="16" width="7" height="5" rx="1"/></svg>,
  orders: () => <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2"/><rect x="9" y="3" width="6" height="4" rx="1"/><line x1="8" y1="12" x2="16" y2="12"/><line x1="8" y1="16" x2="13" y2="16"/></svg>,
  trips: () => <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="6" width="15" height="12" rx="1"/><path d="M16 10h4l3 3v5h-7z"/><circle cx="6" cy="20" r="2"/><circle cx="18" cy="20" r="2"/></svg>,
  accounting: () => <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="16" rx="2"/><line x1="7" y1="9" x2="17" y2="9"/><line x1="7" y1="13" x2="13" y2="13"/><line x1="7" y1="17" x2="15" y2="17"/></svg>,
  integration: () => <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="9" width="6" height="6" rx="1"/><rect x="16" y="9" width="6" height="6" rx="1"/><path d="M8 12h8"/></svg>,
  control: () => <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="4" width="16" height="16" rx="2"/><line x1="4" y1="10" x2="20" y2="10"/><circle cx="8" cy="7" r="1"/></svg>,
  reports: () => <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 3v18h18"/><path d="M7 15l4-5 3 3 5-7"/></svg>,
  utilities: () => <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14.7 6.3a4 4 0 10-8.4 8.4L3 18l3 3 3.3-3.3a4 4 0 108.4-8.4z"/></svg>,
  settings: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.7 1.7 0 00.34 1.9l.06.06a2 2 0 11-2.83 2.83l-.06-.06a1.7 1.7 0 00-1.9-.34 1.7 1.7 0 00-1 1.55V21a2 2 0 01-4 0v-.09a1.7 1.7 0 00-1-1.55 1.7 1.7 0 00-1.9.34l-.06.06a2 2 0 11-2.83-2.83l.06-.06a1.7 1.7 0 00.34-1.9 1.7 1.7 0 00-1.55-1H3a2 2 0 010-4h.09a1.7 1.7 0 001.55-1 1.7 1.7 0 00-.34-1.9l-.06-.06a2 2 0 112.83-2.83l.06.06a1.7 1.7 0 001.9.34H9a1.7 1.7 0 001-1.55V3a2 2 0 014 0v.09a1.7 1.7 0 001 1.55 1.7 1.7 0 001.9-.34l.06-.06a2 2 0 112.83 2.83l-.06.06a1.7 1.7 0 00-.34 1.9V9a1.7 1.7 0 001.55 1H21a2 2 0 010 4h-.09a1.7 1.7 0 00-1.55 1z"/></svg>,
  bell: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8a6 6 0 10-12 0c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 01-3.46 0"/></svg>,
  help: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 015.83 1c0 2-3 2-3 4"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>,
  power: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18.36 6.64a9 9 0 11-12.73 0"/><line x1="12" y1="2" x2="12" y2="12"/></svg>,
  chevron: () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
};

// Full section list, same as the sidebar — shown here as plain icon buttons
// (no labels) so the top bar reads as a quick-jump strip, distinct in style
// from the sidebar's icon+label rows.
const SHORTCUTS = [
  { to: '/', label: 'Dashboard', end: true, icon: I.dashboard },
  { to: '/orders', label: 'Orders', icon: I.orders },
  { to: '/trips', label: 'Trips', icon: I.trips },
  { to: '/accounting', label: 'Accounting', icon: I.accounting },
  { to: '/integration', label: 'Integration', icon: I.integration },
  { to: '/fleet', label: 'Control', icon: I.control },
  { to: '/reports', label: 'Reports', icon: I.reports },
  { to: '/utilities', label: 'Utilities', icon: I.utilities }
];

export default function Header({ onLogout }) {
  const [company, setCompany] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    api('/settings').then(setCompany).catch(() => {});
  }, []);

  useEffect(() => {
    function onClickOutside(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) setMenuOpen(false);
    }
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  const initial = company?.company_name?.[0]?.toUpperCase() || '·';

  return (
    <header className="topbar">
      <div className="topbar-shortcuts">
        {SHORTCUTS.map(s => (
          <NavLink key={s.to} to={s.to} end={s.end}
                   className={({isActive}) => 'topbar-icon-btn' + (isActive ? ' active' : '')}
                   title={s.label}>
            <s.icon />
          </NavLink>
        ))}
      </div>

      <div className="topbar-right">
        <NavLink to="/settings" className="topbar-icon-btn" title="Settings"><I.settings /></NavLink>
        <button className="topbar-icon-btn" title="Notifications">
          <I.bell />
          <span className="topbar-badge">0</span>
        </button>
        <button className="topbar-icon-btn" title="Help">
          <I.help />
        </button>

        <div className="topbar-company" ref={menuRef}>
          <button className="topbar-company-btn" onClick={() => setMenuOpen(o => !o)}>
            <span className="topbar-avatar">{initial}</span>
            <span className="topbar-company-name">{company?.company_name || 'Loading...'}</span>
            <I.chevron />
          </button>
          {menuOpen && (
            <div className="topbar-menu">
              <div className="topbar-menu-item" style={{color:'var(--text-dim)', cursor:'default'}}>
                {company?.account_type || ''}
              </div>
              <NavLink to="/settings" className="topbar-menu-item" onClick={() => setMenuOpen(false)}>Company settings</NavLink>
              <button className="topbar-menu-item" onClick={onLogout} style={{display:'flex', alignItems:'center', gap:8}}>
                <I.power /> Log out
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
